// ABIs for Kingsomni Smart Contracts on Somnia Testnet

export const KINGSOMNI_GAME_ABI = [
  "function claimSTTAndScore(uint256 scoreDelta, uint256 killsDelta, uint256 sttReward, uint256 nonce, bytes memory signature) external",
  "function leaderboards(address) external view returns (uint256 totalScore, uint256 totalKills, uint256 gamesPlayed)",
  "function globalBossActive() external view returns (bool)",
  "function bountyPool() external view returns (uint256)",
  "function highestScore() external view returns (uint256)",
  "function currentLeader() external view returns (address)",
  "event ScoreSubmitted(address indexed player, uint256 scoreDelta, uint256 sttReward)",
  "event BountyClaimed(address indexed winner, uint256 amount)",
  "event GlobalBossToggled(bool active)"
] as const;

export const KINGSOMNI_PROFILE_ABI = [
  "function upgradeStat(uint8 statType) external payable",
  "function unlockSkill(uint8 skillType) external payable",
  "function getPlayerProfile(address player) external view returns (tuple(uint32 damageLevel, uint32 healthLevel, uint32 fireRateLevel, bool unlockFreeze, uint32 freezeLevel, bool unlockHeal, uint32 healLevel, bool unlockDamageBoost, uint32 damageBoostLevel))",
  "function baseUpgradeCost() external view returns (uint256)",
  "function unlockSkillCost() external view returns (uint256)",
  "event StatUpgraded(address indexed player, uint8 statType, uint32 newLevel, uint256 cost)",
  "event SkillUnlocked(address indexed player, uint8 skillType, uint256 cost)"
] as const;

export const KINGSOMNI_TREASURY_ABI = [
  "function deposit() external payable",
  "function claimSTT(address to, uint256 amount) external",
  "event Deposited(address indexed sender, uint256 amount)",
  "event Claimed(address indexed to, uint256 amount)"
] as const;

export const KINGSOMNI_LEADERBOARD_ABI = [
  "function submitScore((address player,uint256 scoreDelta,uint256 killsDelta,bytes32 matchId,uint256 deadline) request, bytes signature) external",
  "function leaderboards(address player) external view returns (uint256 totalScore, uint256 totalKills, uint256 gamesPlayed)",
  "function getPlayersCount() external view returns (uint256)",
  "function getPlayers(uint256 offset, uint256 limit) external view returns (address[] memory playersPage)",
  "function backendSigner() external view returns (address)",
  "event ScoreSubmitted(address indexed player, uint256 scoreDelta, uint256 killsDelta, bytes32 indexed matchId)"
] as const;
